import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=7b860dd6&scoped=true&"
import script from "./FooterContent.vue?vue&type=script&lang=js&"
export * from "./FooterContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b860dd6",
  null
  
)

export default component.exports